import script from "./ClosePopupButtonDestkop.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClosePopupButtonDestkop.vue?vue&type=script&setup=true&lang=ts"

import "./ClosePopupButtonDestkop.vue?vue&type=style&index=0&id=0109b8e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0109b8e4"]])

export default __exports__